import {
    getConnection,
    getCurSession,
    getStatusID,
    setIsBPMChanged
} from '../../../../../_shared/GWTBridge/invoke/bpm/bpmMain';
import {buildServerCall} from '../../../../../services/wcfService';
import {BpmAlertResponse} from './types';
import {handleBPMMessages} from '../utils/handlePermission';
import {bpmRulesStorage} from '../BPM.rules.storage';

export const bpmToggleActiveRule = async (
    fromStatus: string,
    toStatus: string,
    ruleNumber: string,
    isActive: boolean
) => {
    const methodName = 'BPMActiveSaveToSession';
    const reason = 'BPMActiveSaveToSession';

    const fromid = getStatusID(fromStatus)?.toString();
    const toid = getStatusID(toStatus)?.toString();
    const storageData = bpmRulesStorage.getStorage(getCurSession());

    const parameters = {
        session: [getCurSession()],
        isActive: [isActive ? 'Y' : ''],
        alert: [ruleNumber]
    };

    const res: BpmAlertResponse = await buildServerCall(
        methodName,
        parameters,
        reason,
        true,
        getConnection
    );

    const BPM = res?.BPM?.[0];

    const isOk = await handleBPMMessages(BPM);

    if (isOk) {
        // Triggers GWT state change flag
        setIsBPMChanged(true);

        storageData?.toggleActiveRule(fromid, toid, ruleNumber, isActive);
    }

    return isOk;
};
